export default {
  Company: 'company',
  Filter: 'filter',
  Blank: 'blank'
}
